export default __webpack_public_path__ + "static/media/(49).e00b52f9.jpg";